module.exports = __webpack_public_path__ + "static/img/04.ed8d3c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/solution/low-code/04.jpg
// module id = JRir
// module chunks = 1